import { render, staticRenderFns } from "./tendencyChats.vue?vue&type=template&id=6eb1502e&scoped=true"
import script from "./tendencyChats.vue?vue&type=script&lang=js"
export * from "./tendencyChats.vue?vue&type=script&lang=js"
import style0 from "./tendencyChats.vue?vue&type=style&index=0&id=6eb1502e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb1502e",
  null
  
)

export default component.exports